/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_ReactivateInputs */

const en_case_contact_reactivate = /** @type {(inputs: Case_Contact_ReactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reactivate contact`)
};

const pt_br2_case_contact_reactivate = /** @type {(inputs: Case_Contact_ReactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reativar contato`)
};

/**
* | output |
* | --- |
* | "Reactivate contact" |
*
* @param {Case_Contact_ReactivateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_reactivate = /** @type {((inputs?: Case_Contact_ReactivateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_ReactivateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_reactivate(inputs)
	return pt_br2_case_contact_reactivate(inputs)
});